import Modal from '@/components/Modal';
import Button from '@/components/Button';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { SocialType } from '@/helpers/TypesHelper';
import { navigate } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

interface SocialLinkPopupProps {
  maskedName: string;
  existWebId: string;
  socialType: SocialType;
  onLink: () => void;
  onRequestClose: () => void;
}

const SOCIAL_LABELS: Record<string, string> = {
  K: `카카오`,
  N: `네이버`,
  G: `구글`,
  F: `페이스북`,
};

const PopupTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #1cabe2;
  text-align: left;
  padding: 32px 32px 0;
  ${breakpoint(`mobile`)} {
    font-size: 18px;
    padding: 24px 24px 0;
  }
`;

const PopupBody = styled.div`
  padding: 24px 32px;
  text-align: center;
  font-size: 16px;
  line-height: 1.8;
  letter-spacing: -0.8px;
  ${breakpoint(`mobile`)} {
    padding: 20px 24px;
    font-size: 14px;
  }
`;

const WebIdDisplay = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #2d2926;
  padding: 12px 0;
  ${breakpoint(`mobile`)} {
    font-size: 16px;
  }
`;

const PopupFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px 32px;
  gap: 16px;
  ${breakpoint(`mobile`)} {
    padding: 0 24px 24px;
  }
`;

const LoginLink = styled.a`
  font-size: 14px;
  color: #666;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #1cabe2;
  }
`;

const SocialLinkPopup: FC<SocialLinkPopupProps> = ({
  maskedName,
  existWebId,
  socialType,
  onLink,
  onRequestClose,
}) => {
  const socialLabel = SOCIAL_LABELS[socialType] || socialType;

  return (
    <Modal
      maxWidth="440px"
      onRequestClose={onRequestClose}
      zIndex="1000"
    >
      <PopupTitle>간편 로그인 안내</PopupTitle>
      <PopupBody>
        <p>{maskedName} 후원자님,</p>
        <p>이미 가입된 웹 아이디가 있습니다.</p>
        <WebIdDisplay>{existWebId}</WebIdDisplay>
        <p>변경을 원하시면 아래 버튼을 눌러주세요.</p>
      </PopupBody>
      <PopupFooter>
        <Button
          full
          onClick={onLink}
          css={`
            background-color: #1cabe2;
            border-color: #1cabe2;
            color: #fff;
            &:hover {
              background-color: #1899cc;
              border-color: #1899cc;
            }
          `}
        >
          {socialLabel}로 연동하기
        </Button>
        <LoginLink
          onClick={() => navigate(`/auth/login`)}
        >
          기존 아이디로 로그인하기
        </LoginLink>
      </PopupFooter>
    </Modal>
  );
};

export default SocialLinkPopup;
